import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgControls = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M9.728 15.509h4.909V8.25H9.728v2.13H3v3h6.728zm28.901 16.982H33.72v7.259h4.909v-2.13H45v-3h-6.371zm-17.084-4.862h4.909V20.37h-4.909v2.13H3v3h18.545zM17.384 10.38H45v3H17.384zM29.201 22.5h15.798v3H29.201zM3 34.62h27.616v3H3z" }) }) })
});
export default SvgControls;
